import angular from 'angular';

/**
 * @memberOf app
 * @ngdoc filter
 * @name app.filter:map
 * @function
 * @description
 * # map
 * Returns array populated with the values supplied by a key.
 * @example
 *   Usage:
 *   <p>{{ ARRAY | map:KEY }}</p>
 *
 *   // list = [{id: 2, name: 'red', id: 7, name: 'green', id: 9, name: 'blue'}]
 *   <p ng-repeat="item in list | map:'id'">
 *     {{ item }}
 *   </p>
 *   // returns <p>2</p> <p>7</p> <p>9</p>
 */
// eslint-disable-next-line angular/function-type
angular.module('app')
	.filter(
		'map',
		/* @ngInject */ () => (input, key) => {
			let result = [];
			if (angular.isArray(input)) {
				result = input.map(o => o[key]);
			}
			return result;
		});
